

export const OUTCOME_LABELS = {
  advice_provided: "Advice Given",
  matter_resolved: "Matter Resolved",
  follow_up_recommended: "Follow-up Recommended",
  representation_required: "Representation Needed",
  documentation_required: "Documentation Required",
  further_evidence_required: "More Evidence Needed",
};
export const FOLLOW_UP_OPTIONS = [
  { key: "7d", label: "7 Days" },
  { key: "15d", label: "15 Days" },
  { key: "30d", label: "30 Days" },
  { key: "custom", label: "Custom Date" },
];
export const NEXT_STEP_PRESETS = [
  "Send Legal Notice",
  "Gather Additional Documents",
  "File Police Complaint",
  "Negotiate Settlement",
  "Schedule Follow-up Consultation",
];

export const EMPTY = {
  matter_title: "",
  client_issue: "",
  facts: [],
  documents_reviewed: [],
  legal_opinion: "",
  recommended_steps: [],
  follow_up: { recommended: false, after: "", after_date: "", note: "" },
  outcome: [],
  internal_notes: "",
};

export function buildForm(lcr) {
  return {
    matter_title: lcr?.matter_title || "",
    client_issue: lcr?.client_issue || "",
    facts: [...(lcr?.facts || [])],
    documents_reviewed: [...(lcr?.documents_reviewed || [])],
    legal_opinion: lcr?.legal_opinion || "",
    recommended_steps: [...(lcr?.recommended_steps || [])],
    follow_up: { recommended: false, after: "", after_date: "", note: "", ...(lcr?.follow_up || {}) },
    outcome: [...(lcr?.outcome || [])],
    internal_notes: lcr?.internal_notes || "",
  };
}
